import * as i0 from '@angular/core';
import { Injectable, Optional, Pipe, NgModule } from '@angular/core';
function localeIdFactory() {
  return localStorage.getItem('localeId');
}
function localeInitilizer() {
  return () => {
    return new Promise((resolve, reject) => {
      return window['DvHello'].getLanguage().then(lang => {
        console.log('getLang ' + lang);
        localStorage.setItem('currentLang', lang);
        // get correct localeId for i18n
        var localeId = 'en-us';
        switch (lang) {
          case 'sv':
            localeId = 'sv';
            break;
          case 'no':
            localeId = 'nb';
            break;
          case 'fi':
            localeId = 'fi';
            break;
          case 'nl':
            localeId = 'nl';
            break;
          case 'de':
            localeId = 'de';
            break;
          case 'fr':
            localeId = 'fr';
            break;
          case 'pl':
            localeId = 'sv';
            break;
          case 'lt':
            localeId = 'lt';
            break;
          case 'cs':
            localeId = 'cs';
            break;
          case 'ru':
            localeId = 'ru';
            break;
          case 'ar':
            localeId = 'ar';
            break;
        }
        localStorage.setItem('localeId', localeId);
        resolve();
      }, reject);
    });
  };
}
let TranslateService = /*#__PURE__*/(() => {
  class TranslateService {
    constructor(config) {
      this.dvTranslate = 'dvTranslate2';
      this.site = '';
      this.data = ["Aktiv", "Inaktiv", "Arbete", "Transport", "Stillastående", "Aktiv körning", "Ej taggat arbete", "Ej taggad transport", "Ingen gröda", "Utförd", "Ej utförd"];
      console.log('init translate service');
      var lang = localStorage.getItem('currentLang');
      if (config) {
        this.site = config.appKey;
        this.init(config.baseUrl + '/', this.site, config.debug, lang);
      }
    }
    init(host, site, debug, defaultLang) {
      if (window[this.dvTranslate]) window[this.dvTranslate].init(host, site, debug, defaultLang);
    }
    t(key, ...args) {
      var argumentsArray = [];
      argumentsArray.push(this.site);
      argumentsArray.push(key || '');
      for (var i = 0; i < args.length; i++) argumentsArray.push(args[i]);
      var text;
      if (window[this.dvTranslate] && window[this.dvTranslate].translate) {
        text = window[this.dvTranslate].translate.apply(this, argumentsArray);
        return text.charAt(0).toUpperCase() + text.slice(1);
      }
      return key || '';
    }
    tl(key, ...args) {
      var argumentsArray = [];
      argumentsArray.push(this.site);
      argumentsArray.push(key || '');
      for (var i = 0; i < args.length; i++) argumentsArray.push(args[i]);
      var text;
      if (window[this.dvTranslate] && window[this.dvTranslate].translate) {
        text = window[this.dvTranslate].translate.apply(this, argumentsArray);
        return text;
      }
      return key || '';
    }
    appendData(data) {
      this.data.push(...data);
    }
    tData(text) {
      if (!text) return text;
      if (this.data.indexOf(text) !== -1) return this.t(text);
      return text;
    }
    getLang() {
      return window[this.dvTranslate].getLang(this.site);
    }
    setLang(lang) {
      if (window[this.dvTranslate]) window[this.dvTranslate].setLang(this.site, lang);
    }
    static {
      this.ɵfac = function TranslateService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TranslateService)(i0.ɵɵinject(TranslateServiceConfig, 8));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: TranslateService,
        factory: TranslateService.ɵfac
      });
    }
  }
  return TranslateService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class TranslateServiceConfig {}
let TranslateBoolPipe = /*#__PURE__*/(() => {
  class TranslateBoolPipe {
    constructor(_translateService) {
      this._translateService = _translateService;
    }
    transform(value, trueText, falseText) {
      if (value) return this._translateService.t(trueText);else return this._translateService.t(falseText);
    }
    static {
      this.ɵfac = function TranslateBoolPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TranslateBoolPipe)(i0.ɵɵdirectiveInject(TranslateService, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "dvtb",
        type: TranslateBoolPipe,
        pure: true,
        standalone: false
      });
    }
  }
  return TranslateBoolPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TranslatePipe = /*#__PURE__*/(() => {
  class TranslatePipe {
    constructor(_translateService) {
      this._translateService = _translateService;
    }
    transform(key, ...args) {
      var text = this._translateService.tl(key, ...args);
      if (!text) return text;
      return text.charAt(0).toUpperCase() + text.slice(1);
    }
    static {
      this.ɵfac = function TranslatePipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TranslatePipe)(i0.ɵɵdirectiveInject(TranslateService, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "dvt",
        type: TranslatePipe,
        pure: true,
        standalone: false
      });
    }
  }
  return TranslatePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TranslateLowPipe = /*#__PURE__*/(() => {
  class TranslateLowPipe {
    constructor(_translateService) {
      this._translateService = _translateService;
    }
    transform(key, ...args) {
      var text = this._translateService.tl(key, ...args);
      if (!text) return text;
      return text.toLowerCase();
    }
    static {
      this.ɵfac = function TranslateLowPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TranslateLowPipe)(i0.ɵɵdirectiveInject(TranslateService, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "dvtl",
        type: TranslateLowPipe,
        pure: true,
        standalone: false
      });
    }
  }
  return TranslateLowPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TranslateCasePipe = /*#__PURE__*/(() => {
  class TranslateCasePipe {
    constructor(_translateService) {
      this._translateService = _translateService;
    }
    transform(key, ...args) {
      return this._translateService.tl(key, ...args);
    }
    static {
      this.ɵfac = function TranslateCasePipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TranslateCasePipe)(i0.ɵɵdirectiveInject(TranslateService, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "dvtc",
        type: TranslateCasePipe,
        pure: true,
        standalone: false
      });
    }
  }
  return TranslateCasePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TranslateDataPipe = /*#__PURE__*/(() => {
  class TranslateDataPipe {
    constructor(_translateService) {
      this._translateService = _translateService;
    }
    transform(key, ...args) {
      return this._translateService.tData(key);
    }
    static {
      this.ɵfac = function TranslateDataPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TranslateDataPipe)(i0.ɵɵdirectiveInject(TranslateService, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "dvtd",
        type: TranslateDataPipe,
        pure: true,
        standalone: false
      });
    }
  }
  return TranslateDataPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TranslateModule = /*#__PURE__*/(() => {
  class TranslateModule {
    static forRoot(config) {
      return {
        ngModule: TranslateModule,
        providers: [TranslateService, {
          provide: TranslateServiceConfig,
          useValue: config
        }]
      };
    }
    static {
      this.ɵfac = function TranslateModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TranslateModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: TranslateModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return TranslateModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of dv-translate
 */

/**
 * Generated bundle index. Do not edit.
 */

export { TranslateBoolPipe, TranslateCasePipe, TranslateDataPipe, TranslateLowPipe, TranslateModule, TranslatePipe, TranslateService, TranslateServiceConfig, localeIdFactory, localeInitilizer };
